import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown(event) {
    if (this.#isEditable(event.target)) return;

    if (event.metaKey && event.shiftKey && event.code === "Comma") {
      event.preventDefault();
      if (window.Turbo) {
        window.Turbo.visit("/settings");
      } else {
        window.location.href = "/settings";
      }
    }
  }

  #isEditable(el) {
    if (!el) return false;
    const tag = el.tagName;
    return (
      tag === "INPUT" ||
      tag === "TEXTAREA" ||
      tag === "SELECT" ||
      el.isContentEditable
    );
  }
}
